import Link from 'next/link';
import styled from 'styled-components';

import { LocalizedCurrency } from 'shared/components/LocalizedCurrency';
import { variableFontRegular } from 'styles/theme/text';

export interface IWindowItemShortTextProps {
  isPriceOption?: boolean;
  link?: string;
  onTextClick?: (e: any) => void;
  price?: number;
  showLink?: boolean;
  text?: string;
  title: string;
}

export const WindowItemShortText = ({
  isPriceOption = false,
  link,
  onTextClick,
  price,
  showLink = false,
  text,
  title,
}: IWindowItemShortTextProps) => {
  const textDisplay = isPriceOption ? <LocalizedCurrency price={price} /> : <span>{text}</span>;

  return (
    <WindowItemShortText.Wrapper className="window-item">
      <WindowItemShortText.Title>{title}</WindowItemShortText.Title>
      <WindowItemShortText.Right>
        {onTextClick && !showLink && (
          <WindowItemShortText.Link
            data-qa={`${title?.toLowerCase()?.replace(' ', '_')}_sort_text`}
            onClick={onTextClick}
            type="button"
          >
            {textDisplay}
          </WindowItemShortText.Link>
        )}
        {onTextClick && showLink && (
          <Link href={link} passHref prefetch={false}>
            <a data-qa="window_item_link">{textDisplay}</a>
          </Link>
        )}
        {!onTextClick && (text || price) && textDisplay}
      </WindowItemShortText.Right>
    </WindowItemShortText.Wrapper>
  );
};

WindowItemShortText.Wrapper = styled.div`
  align-items: flex-start;
  border-bottom: ${({ theme }) => theme.borders.black};
  display: flex;
  flex-direction: row;
  padding: 16px;
  text-transform: capitalize;
  justify-content: space-between;

  html[lang='fr-fr'] & {
    text-transform: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })}
  }
`;

WindowItemShortText.Title = styled.span`
  width: 50%;

  ${variableFontRegular({ height: '14px', size: '9.5px' })}
`;

WindowItemShortText.Right = styled.span`
  pointer-events: all;
  text-align: right;
  width: 50%;
`;

WindowItemShortText.Link = styled.button`
  padding: 0;
  text-align: right;
  text-decoration: underline;
`;
